import styled from "@emotion/styled"

export const Times = styled.div`
  font-size: 5rem;
  color: #fff;
  grid-area: t;
  align-self: end;
  font-size: 6.5rem;
`
